import { computed } from 'vue';
import store from '@/store';

/**
 * Ventas restringidas puntuales: un usuario concreto (identificado por el email
 * con el que hace login) no puede vender en taquilla en un evento concreto.
 *
 * La misma regla se aplica en dos capas para que no quede un acceso alternativo:
 *   - el listado de sesiones del evento esconde el botón «Venta»
 *     (EventosActuales.vue y EventosPasados.vue),
 *   - el guard de la ruta `back.events.venta` corta la entrada directa por URL.
 *
 * Alcance: es una restricción de interfaz, no un control de seguridad. La API
 * `back.events.venta-taquilla` sigue aceptando la petición si se lanza a mano,
 * así que el bloqueo definitivo corresponde al backend.
 */
export const VENTAS_RESTRINGIDAS = [
    {
        // Taquilla del club visitante (Club Deportivo Estepona).
        email: 'taquillavisitante2@clubdeportivoestepona.com',
        evento_id: 22675
    }
];

/**
 * Indica si el usuario tiene la venta bloqueada en ese evento.
 *
 * Es una regla pura: sin usuario cargado (login todavía asíncrono) devuelve
 * false, de modo que la decisión se toma cuando el store ya tiene el usuario.
 *
 * @param {number|string} eventoId identificador del evento; en rutas llega como string
 * @param {{email?: string}|null} user usuario logueado del store
 * @returns {boolean} true cuando la venta está restringida
 */
export function esVentaRestringida(eventoId, user) {
    if (!user || !user.email || eventoId === undefined || eventoId === null) {
        return false;
    }

    const email = String(user.email).trim().toLowerCase();
    const evento = Number(eventoId);

    return VENTAS_RESTRINGIDAS.some(restringida => {
        return restringida.email === email && restringida.evento_id === evento;
    });
}

/**
 * Versión reactiva para componentes: lee el usuario del store, así que al
 * llegar del login asíncrono la vista se recalcula sola.
 *
 * @returns {{puedeVenderEnEvento: (eventoId: number|string) => boolean}}
 */
export function useVentaRestringida() {
    const user = computed(() => store.getters.getUser);

    function puedeVenderEnEvento(eventoId) {
        return !esVentaRestringida(eventoId, user.value);
    }

    return {
        puedeVenderEnEvento
    };
}
